<script lang="ts">
  import { onMount } from 'svelte';
  import { auth } from '$lib/stores/auth';
  import { createPayment, getAccountStatus } from '$lib/api/payments';
  import { supabase } from '$lib/supabaseClient';

  let amount = 9900;
  let description = 'Minertia test subscription';
  let testMode = true;
  let message = '';
  let loading = false;
  let account: { plan?: string; paid_at?: string } | null = null;
  let userEmail = '';

  let currentUserId = '';

  async function refreshAccount() {
    const result = await getAccountStatus();
    account = result?.profile ?? null;
  }

  $: if ($auth.user?.id && $auth.user.id !== currentUserId) {
    currentUserId = $auth.user.id;
    refreshAccount();
  }

  async function handlePayment() {
    loading = true;
    message = '';

    try {
      const payment = await createPayment(amount, description, testMode);
      message = `Payment ${payment.payment.status} (${payment.payment.id})`;
      await refreshAccount();
    } catch (error) {
      message = error instanceof Error ? error.message : 'Payment failed';
    } finally {
      loading = false;
    }
  }

  onMount(async () => {
    const session = await supabase.auth.getSession();
    userEmail = session.data.session?.user?.email ?? '';
    if (userEmail) {
      await refreshAccount();
    }
  });
</script>

<section class="payment-section">
  <h2>Subscription & Payment</h2>

  {#if $auth.loading}
    <p>Checking authentication…</p>
  {:else if !$auth.user}
    <p>Please sign in first to access the payment page.</p>
  {:else}
    <p>Signed in as <strong>{$auth.user.email}</strong></p>
    <p>Account plan: <strong>{account?.plan ?? 'free'}</strong></p>
    {#if account?.paid_at}
      <p>Paid at {new Date(account.paid_at).toLocaleString()}</p>
    {/if}

    <div class="form-group">
      <label>Amount (ZAR cents)</label>
      <input type="number" bind:value={amount} min="100" />
    </div>

    <div class="form-group">
      <label>Description</label>
      <input type="text" bind:value={description} />
    </div>

    <div class="form-group checkbox-row">
      <label><input type="checkbox" bind:checked={testMode} /> Test mode (no real charge)</label>
    </div>

    <button on:click={handlePayment} disabled={loading}>
      {loading ? 'Processing…' : 'Pay with Stitch'}
    </button>

    {#if message}
      <p class="message">{message}</p>
    {/if}
  {/if}
</section>

<style>
  .payment-section {
    max-width: 540px;
    margin: 2rem auto;
    padding: 1.75rem;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    background: #fff;
  }

  h2 {
    margin: 0 0 1rem;
    font-size: 1.6rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  input[type='text'],
  input[type='number'] {
    padding: 0.75rem;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    font-size: 1rem;
  }

  .checkbox-row {
    align-items: center;
    display: flex;
  }

  button {
    width: 100%;
    padding: 0.85rem 1rem;
    border: none;
    border-radius: 8px;
    background: #0f62fe;
    color: white;
    font-size: 1rem;
    cursor: pointer;
  }

  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .message {
    margin-top: 1rem;
    color: #333;
  }
</style>
